<template>
    <AppHeader :accountData="accountData" :locale="locale" :localTranslation="localTranslation" />
    <main itemscope="" itemtype="https://schema.org/WebPage">
        <AppTitleBlock :pageTitle="pageData.pageTitle" :isCheckout="pageData.isCheckout" :SelectedData="SelectedData" :accountData="accountData" :steps="steps" @changeStep="changeStep($event)" />
        <section class="contentSection" itemprop="mainContentOfPage">
            <div class="full-col">
                <Loader v-if="loading" />
                <CheckoutRegisterPopup
                    :SelectedData="SelectedData"
                    v-if="SelectedData.stepActive == 'Step 5'"
                />
                <div class="col" :class="{'col_2_of_2' : fullCol, 'col_2_of_3' : colSteps}" ref="checkouttop">
                    <transition name="fade">
                        <CheckoutErrorMessages :errors="errors" v-if="errors && !isLoading" />
                    </transition>
                    <transition name="fade">
                        <CheckoutWordLimitValidation
                            :turnaround="SelectedData.turnaround"
                            :turnarounds="CheckoutData.turnarounds"
                            :numberWords="SelectedData.numberWords"
                            :maxLimit="CheckoutData.turnarounds[0].WordLimit"
                            :SelectedData="SelectedData"
                            :CheckoutData="CheckoutData"
                            v-if="wordLimitMet && !isLoading"
                        />
                    </transition>
                    <router-view 
                    @loaded="loading=false" 
                    v-show="!loading" 
                    @updateSelected="updateSelected($event)"
                    @goToStep="goToStep($event)" 
                    :CheckoutData="CheckoutData"
                    :accountData="accountData"
                    :SelectedData="SelectedData"
                    :totals="totals"
                    :localTranslation="localTranslation" />

                    <div class="checkoutFormHolder" style="padding-top:0;margin-top: -15px;">
                        <div style="width: 300px;" v-show="this.SelectedData.stepActive == 'Step 4' && SelectedData.billingData.paymentType == 'paypal'">
                            <div id="paypal-button-container" class="paypal-button-container" ></div>
                        </div>
                            <div style="width: 300px;" v-show="this.SelectedData.stepActive == 'Step 4' && SelectedData.billingData.paymentType == 'venmo'">
                            <div id="venmo-button" class="venmo-button" ></div>
                        </div>
                        <div id="venmo-button-container"></div>
                    </div>
                </div>
                <CheckoutRightCol v-if="pageData.isCheckout && !loading && colSteps" />
                <div class="clearAll"></div>
                
                
            </div>
        </section>
    </main>
    <AppFooter :localTranslation="localTranslation" />
</template>
<script>
import axios from 'axios';
import Loader from '@/components/Loader.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppTitleBlock from '@/components/AppTitleBlock.vue'
import AppFooter from '@/components/AppFooter.vue'
import CheckoutRightCol from '@/components/checkout/CheckoutRightCol.vue'
import PricesFunctions from '@/mixins/PricesFunctions.vue';
import TestPrefill from '@/mixins/TestPrefill.vue';
import CheckoutStep1Validation from '@/mixins/CheckoutStep1Validation.vue';
import CheckoutStep3Validation from '@/mixins/CheckoutStep3Validation.vue';
import CheckoutErrorMessages from '@/components/checkout/CheckoutErrorMessages.vue';
import CheckoutWordLimitValidation from '@/components/checkout/CheckoutWordLimitValidation.vue';
import CheckoutRegisterPopup from '@/components/checkout/CheckoutRegisterPopup.vue';
import { ErrorService } from "@/components/ErrorService.vue";
import GooglePay from '@/components/checkout/PaymentApi.vue';
export default {
    mixins: [PricesFunctions, TestPrefill, CheckoutStep1Validation,CheckoutStep3Validation, GooglePay],
    components: {
        AppHeader,AppFooter,AppTitleBlock,CheckoutRightCol,Loader,CheckoutErrorMessages,CheckoutWordLimitValidation,CheckoutRegisterPopup
    },
    data: () => {
        return {
            isLoading: true,
            errors: false,
            wordLimitMet: false,
            pageSubTitle: '',
            Currentyear: new Date().getFullYear(), // for copyrights in footer
            dataLoaded: false,
            couponSuccessMessage: false,
            firstLoad: true,
            movingStepsActive: false,
            locale: 'en',
            steps: {
                step1: { completed: false },
                step2: { completed: false },
                step3: { completed: false },
                step4: { completed: false },
                step5: { completed: false }
            },
            localTranslation: {},
            preselectTurnaround: false,
            SelectedData: {
                invoice: false,
                stepActive: 'Translation Type',
                liveTracking: false,
                quoteCode: false,
                minAmountUsed: false,
                totalBeforeMinAmount: false,
                upgrade: '',
                translationType: 'basic',
                translateFrom: false,
                translateTo: false,
                turnaround: false,
                expertise: false,
                numberWords: '',
                fileUploaded: '',
                styleGuide: '',
                namesPlaces: '',
                identification: '',
                description: '',
                firstName: '',
                lastName: '',
                address1: '',
                address2: '',
                city: '',
                state: {label: 'Select State'},
                zip: '',
                country: {label: 'Select Country'},
                birthday: { mm: '', dd: '', yy: '' },
                confirmBirthday: { mm: '', dd: '', yy: '' },
                email: '',
                confirmEmail: '',
                cell: '',
                billingData: {
                    paymentType: '',
                    creditCardType: '',
                    creditCardNumber: '',
                    cvv2Number: '',
                    expirationDate: { mm: '', yy: '' }
                },
                couponCode: '',
                couponData: {
                    couponCode: ''
                },
            },
            CheckoutData: {
                fromCountries: [{value:'Select'}],
            },
            accountData: {CustomerType: 'guest'},
            loading: true,
        }
    },
    created: function() { 
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const invoice = urlParams.get('invoice');
        const PayerID = urlParams.get('PayerID');
        const act = urlParams.get('act');
        const id = urlParams.get('id');
        const code = urlParams.get('code');
        const locale = urlParams.get('locale');
        if (id) {
            if (id > 0) {
                this.preselectTurnaround = id;
            }
        }
        if (code) {
            this.SelectedData.quoteCode = code;
        }
        if(locale) {
            this.locale = locale;
        }
        if (token) {
            this.SelectedData.PaypalExpress = {};
            this.SelectedData.PaypalExpress.token = token;
            this.SelectedData.invoice = invoice;
            this.SelectedData.PaypalExpress.PayerID = PayerID;
            this.SelectedData.PaypalExpress.act = act;
        } else {
            this.SelectedData.invoice = new Date().getTime();
            //this.SelectedData.invoice = 1621520875206;
            //this.$router.push({ name: 'Step 1' });
        }
        if(this.SelectedData.invoice == '' || !this.SelectedData.invoice) {
            this.SelectedData.invoice = new Date().getTime();
        }
        //throw new Error('Error text.');
        //console.log(act);
        //this.testDataPrefill();
    },
    mounted () {
        this.load();
    },
    watch: {
        dataLoaded: function() {
            if (this.dataLoaded) {
                if (this.SelectedData.PaypalExpress) {
                    this.getSavedData(this.SelectedData.PaypalExpress.token, this.SelectedData.PaypalExpress.act);
                }
            }
        },
        $route(to) {
            console.log(this.$route.name);
            if(to.name && !this.stepActive) {
                this.SelectedData.stepActive = this.$route.name;
                //console.log(this.$route.name);
            }
        },
    },
    computed: {
        colSteps() {
            if(this.SelectedData.stepActive != 'Translation Type') {
                return true;
            }
            return false;
        },
        fullCol() {
            if(this.SelectedData.stepActive == 'Translation Type') {
                return true;
            }
            return false;
        },
        pageData() {
            const returnData = {
                pageTitle: 'Checkout',
                isCheckout: true
            };
            if(this.$route.name == 'Translation Type' || this.$route.name == 'Translation Type Id') {
                returnData.pageTitle = 'Choose Translation Type';
                returnData.isCheckout = false;
            }
            return returnData;
        },
        apiUniqueNumber() {
            return Math.ceil(Math.random()*1000000);
        }, 
        turnaroundIdParam() {
            return this.$route.params.id;
        },
        apiUrl() {
            return import.meta.env.VITE_API_PATH;
        },
        totals: function() {
            if (
                this.SelectedData.numberWords > 0 &&
                this.getPriceValue
            ) {
                // get starting amount
                let amount = this.getBasicPrice();
                amount = this.checkMinimalAmount(amount);
                const object = {};
                object.amount = amount;
                let total = amount;

                // get other options like surcharges, coupons ...
                object.totalOptions = this.getTotalOptions(amount);
                const totalOptions = object.totalOptions;
                totalOptions.map(function(value) {
                    total = value.total;
                });
                total = parseFloat(total);
                object.total = total.toFixed(2);
                return object;
            }
            return false;
        },
    },
    methods: {
        load() {
            this.$router.push({ name: 'Translation Type' });
            this.getLocale();
            this.getData();
            this.getAccountData();
            //this.goToStep({step: 4, translationType:'Certified'})
        },
        changeStep(stepVal) {
            if(this.SelectedData.stepActive == 'Step 5') {
                return false;
            }
            const stepVar = 'step'+stepVal;
            if(this.steps[stepVar].completed) {
                this.goToStep({ step: stepVal });
            }
        },
        goToStep(params) {
            this.loading = true;
            if(params.translationType) {
                this.SelectedData.translationType = params.translationType; 
                if(this.SelectedData.translationType == 'certified') {
                    this.SelectedData.expertise = 'Certified';
                }
            }
            let stepName = 'Step '+params.step;
            this.checkWordLimit();
            if(params.step > 1 && (!this.validateStep1() || this.wordLimitMet)) {
                this.loading = false;
                return false;
            }
            if(params.step > 3 && !this.validateStep3() && this.accountData.CustomerType != 'corporate') {
                this.loading = false;
                return false;
            }
            if(params.step == 2) {
                this.steps.step1.completed = true;
            } else if(params.step == 3 && this.accountData.CustomerType == 'corporate') {
                this.steps.step2.completed = true;
                params.step = 4;
            } else if(params.step == 3) {
                this.steps.step2.completed = true;
            } else if(params.step == 4) {
                this.steps.step3.completed = true;
            } else if(params.step == 5) {
                this.steps.step4.completed = true;
            } else if(params.step == 4) {
                this.steps.step3.completed = true;
            } else if(params.step == 5) {
                this.steps.step4.completed = true;
            }
            if(this.accountData.CustomerType == 'corporate') {
                if(stepName == 'Step 3') {
                    stepName = 'Step 4';
                } else if(stepName == 'Step 4') {
                    stepName = 'Step 5';
                }
            }

            if(stepName == 'Step 4') {
                if((this.SelectedData.billingData.paymentType == 'paypal' || this.SelectedData.billingData.paymentType == 'venmo') && this.accountData.CustomerType != 'corporate') {
                    this.loadPaymentButtons();
                    //this.preparePaymentExpress();
                }
            }

            if(stepName == 'Step 5') {
                if(this.accountData.CustomerType != 'corporate') {
                    if(this.SelectedData.billingData.paymentType == 'googlepay') {
                        this.onGooglePaymentButtonClicked();
                        this.isLoading = false;
                    } else {
                        this.processOrder(params.step); 
                    }
                } else {
                    this.processOrder(params.step); 
                }
                
            } else {
                this.SelectedData.stepActive = stepName;
                this.$router.push({ name: stepName });
                if(this.SelectedData.stepActive == stepName) {
                    this.loading = false;
                }
                
            }
            window.scrollTo(0, 0);
        },
        getSavedData(token, act) {
            this.loading = true;
            this.isLoading = true;
            const email = this.SelectedData.email
            axios
                .get(
                    this.apiUrl +
                        'API/SavedDataPull.php?apiUnique='+this.apiUniqueNumber+'&token=' +
                        token +'&ACT='+act+'&email='+email
                )
                .then(response => {
                    console.log(response.data);
                    if (response.data.SelectedData != 'false') {
                        const PaypalExpress = this.SelectedData.PaypalExpress;
                        this.SelectedData = response.data.SelectedData;
                        this.SelectedData.PaypalExpress = PaypalExpress;
                        if (PaypalExpress.act == 'ret') {
                            this.stepActive = 'Step 4';
                            this.steps.step1.completed = true;
                            this.steps.step2.completed = true;
                            this.steps.step3.completed = true;
                            this.steps.step4.completed = true;
                            //this.$router.push({ name: 'Step 4' });
                            this.processOrder(5);
                            
                        } else if (PaypalExpress.act == 'cancel') {
                            this.stepActive = 'Step 3';
                            this.steps.step2.completed = true;
                            this.$router.push({ name: 'Step 3' });
                            this.isLoading = false;
                            this.loading = false;
                        }
                    } else {
                        this.SelectedData.PaypalExpress = false;
                        this.SelectedData.invoice = new Date().getTime();
                        this.loading = false;
                    }
                });
        },
        getLocale() {
            axios
                .get(
                    this.apiUrl +
                        'API/GetLocaleJson.php?apiUnique='+this.apiUniqueNumber+'&locale='+this.locale
                )
                .then(response => {
                    this.localTranslation = response.data;
                });
        },
        getData() {
            this.isLoading = true;
            axios
                .get(
                    this.apiUrl +
                        'API/CheckoutData.php?apiUnique='+this.apiUniqueNumber
                )
                .then(response => {
                    this.CheckoutData = response.data.data;
                    if (this.preselectTurnaround) {
                        for (const value in this.CheckoutData.turnarounds) {
                            if (
                                this.CheckoutData.turnarounds[value].ID ==
                                this.preselectTurnaround
                            ) {
                                this.SelectedData.turnaround = this.CheckoutData.turnarounds[
                                    value
                                ];
                            }
                        }
                    }
                    setTimeout(() => (this.isLoading = false), 500);
                }).catch(
                    function (error) {
                        ErrorService.handleError(error);
                    }
                );
        },
        async getAccountData() {
            axios
                .get(
                    this.apiUrl +
                        'API/AccountData.php?action=getAccountData&apiUnique='+this.apiUniqueNumber
                )
                .then(response => {
                    if(!response.data.is_loged) {
                        this.accountData.CustomerType = 'guest';
                    } else {
                        this.accountData = response.data.accountData;
                        const accData = this.accountData;
                        this.SelectedData.firstName = accData.FirstName;
                        this.SelectedData.lastName = accData.LastName;
                        this.SelectedData.address1 = accData.Address1;
                        this.SelectedData.address2 = accData.Address2;
                        this.SelectedData.city = accData.City;
                        this.SelectedData.state.value = accData.State;
                        this.SelectedData.state.label = accData.State;
                        this.SelectedData.zip = accData.Zip;
                        this.SelectedData.country.value = accData.Country;
                        this.SelectedData.country.label = accData.Country;
                        this.SelectedData.birthday.mm = accData.BirthdayMonth;
                        this.SelectedData.birthday.dd = accData.BirthdayDay;
                        this.SelectedData.birthday.yy = accData.BirthdayYear;
                        this.SelectedData.confirmBirthday.mm =
                            accData.BirthdayMonth;
                        this.SelectedData.confirmBirthday.dd =
                            accData.BirthdayDay;
                        this.SelectedData.confirmBirthday.yy =
                            accData.BirthdayYear;
                        this.SelectedData.email = accData.Email;
                        this.SelectedData.confirmEmail = accData.Email;
                        this.SelectedData.cell = accData.Cell;
                    }
                    this.dataLoaded = true;
                }).catch(
                    function (error) {
                        ErrorService.handleError(error);
                    }
                );
        },
        preparePaymentExpress() {
            const formData = new FormData();
            formData.append('SelectedData', JSON.stringify(this.SelectedData));
            formData.append('totals', JSON.stringify(this.totals));
            axios
                .post(this.apiUrl + 'API/PaypalExpress.php',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    //console.log(response.data);
                    const data = response.data;
                    if(data.Status == 'SUCCESS') {
                        window.location.href = data.Url;
                    }
                });
        },
        processOrder(stepNum) {
            const formData = new FormData();
            formData.append('CheckoutData', JSON.stringify(this.CheckoutData));
            formData.append('SelectedData', JSON.stringify(this.SelectedData));
            formData.append('accountData', JSON.stringify(this.accountData));
            formData.append('totals', JSON.stringify(this.totals));

            console.log(this.SelectedData);
            axios
                .post(this.apiUrl + 'API/OrderProceed.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    let stepName = 'Step '+stepNum;
                    if(response.data.Status == 'ERROR') {
                        stepName = 'Step '+response.data.Step;
                        this.SelectedData.stepActive = stepName;
                        const errors = [];
                        errors.push(response.data.Errors);
                        this.errors = errors;
                    } else {
                        this.SelectedData.orderId = response.data.orderId;
                        this.SelectedData.transactionId = response.data.transactionId; 
                        this.SelectedData.stepActive = 'Step '+stepNum;
                    }
                    this.$router.push({ name: stepName });
                    if(this.SelectedData.stepActive == stepName) {
                        this.loading = false;
                    }
                });
        },
        updateSelected(obj) {
            const isArray = obj instanceof Array;
            if(!isArray) {
                if(obj.name == 'numberWords') {
                    let numWords = parseInt(obj.value);
                    if(isNaN(numWords)) {
                        numWords = '';
                        this.SelectedData.numberWords = numWords;
                    } else {
                        this.SelectedData.numberWords = numWords;
                    }
                    
                } else if(obj.name == 'translateFrom') {
                    this.SelectedData[obj.name] = obj.value;
                    if(!this.SelectedData.translateFrom?.value) {
                        return false;
                    }
                    if(this.CheckoutData.specialTurnarounds.includes(this.SelectedData.turnaround.ID) && !this.CheckoutData.specialLanguages.includes(obj.value.label)) {
                        this.SelectedData.turnaround = false;
                    } else if(!this.CheckoutData.inhouseTurnarounds.includes(this.SelectedData.turnaround.ID) && !this.CheckoutData.inhouseLanguages.includes(obj.value.label)) {
                        this.SelectedData.turnaround = false;
                    }
                } else if(obj.name == 'email' || obj.name == 'confirmEmail') {
                    this.SelectedData[obj.name] = obj.value.trim();
                } else {
                    this.SelectedData[obj.name] = obj.value;
                }
            } else {
                obj.forEach(element => this.SelectedData[element.name] = element.value);
            }
            
        }
    }
}
    
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>